import React from "react";
import { Badge } from "@merge-api/merge-javascript-shared";
import { UnreleasedAPICategory, APICategory } from "../../../models/Entities";
import { subCategoriesForAPICategory, isBetaCategory } from "../../../models/Helpers";

/**
 * Renders a title with an optional Beta badge for beta categories like "Chat".
 * The title and badge will be vertically centered and properly spaced.
 *
 * @param category - The category to display
 * @returns JSX Element with the title and conditional Beta badge
 */
const checkCategoryBetaPublicStatusAndRenderCategoryTitle = (
  category: APICategory | UnreleasedAPICategory,
): JSX.Element => {
  const displayName = subCategoriesForAPICategory(category);
  const isBetaPublicCategory = isBetaCategory(category);

  return (
    <div className="flex items-center">
      <span>{displayName}</span>
      {isBetaPublicCategory && (
        <span className="ml-2 flex items-center">
          <Badge color="blue">Beta</Badge>
        </span>
      )}
    </div>
  );
};

export default checkCategoryBetaPublicStatusAndRenderCategoryTitle;
